import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  Input,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { take } from 'rxjs/operators';
import { EoFormComponent, STATUS } from 'ngx-eo-web-components';

import { AuthService } from '../../../../services/auth/auth.service';
import { CoreService } from '../../core.service';

import {
  userChangePasswordFormConfig,
  changePasswordSubmitButtonLabel,
} from './user-change-password-form.config';

@Component({
  selector: 'app-user-change-password-form',
  templateUrl: './user-change-password-form.component.html',
  styleUrls: ['./user-change-password-form.component.scss'],
})
export class UserChangePasswordFormComponent {
  @ViewChild('eoForm') eoForm?: EoFormComponent;
  @Input() forceChange = false;

  readonly formConfig = userChangePasswordFormConfig;
  readonly submitLabel = changePasswordSubmitButtonLabel;

  visible = false;

  private readonly status$ = this.authService.changePasswordCh.status$;

  constructor(
    private readonly authService: AuthService,
    private readonly coreService: CoreService
  ) {}

  show(): void {
    this.status$.next(STATUS.pending);

    this.visible = true;

    (this.eoForm?.getForm() as FormGroup | undefined)?.reset();
  }

  hide(): void {
    this.visible = false;
    this.forceChange = false;
  }

  isLoading(): boolean {
    return this.status$.getValue() === STATUS.loading;
  }

  onSaveClick(): void {
    const root = this.eoForm?.getForm() as FormGroup | undefined;
    if (!root) {
      return;
    }

    const panel = root.get('password') as FormGroup | null;
    if (!panel) {
      return;
    }

    const { oldPassword, newPassword, confirmPassword } = panel.value;
    if (newPassword !== confirmPassword) {
      return;
    }

    this.status$.next(STATUS.loading);

    this.authService
      .changePassword({
        userName: this.authService.token$.value?.name ?? '',
        oldPassword: oldPassword,
        newPassword: newPassword,
      })
      .pipe(take(1))
      .subscribe({
        next: () => this.onSuccess(),
        error: () => this.onError(),
      });
  }

  private onSuccess(): void {
    this.hide();
    this.coreService.showSuccess(
      'Παρακαλώ μπείτε εκ νέου στην πλατφόρμα χρησιμοποιώντας τον καινούργιο κωδικό',
      'Ο κωδικός χρήστη ενημερώθηκε!'
    );
    this.authService.logout();
  }

  private onError(): void {
    this.status$.next(STATUS.pending);

    this.coreService.showError(
      'Αποτυχία αλλαγής κωδικού. Ελέγξτε τα στοιχεία και προσπαθήστε ξανά.'
    );
  }

  onExitClick(): void {
    this.visible = false;
    this.forceChange = false;
    this.authService.logout();
  }
}
